<template>
	<div class="group-warp">
		
		<div class="header-box">
			<el-button class="edit-btn" type="primary" size="medium" @click="add()">新建商品分组</el-button>
			<div class="header-tip" @click="showeDialogTip()">示例效果图></div>
		</div>
		
		<!-- 列表 -->
		<div  class="list-box">
			<el-table v-loading="loading" :data="list" :row-class-name="tableRowClassName">
				
				<el-table-column prop="name" label="分组名称" width="200" align="left"></el-table-column>
				
				<el-table-column prop="pcount" label="商品数量" width="150" align="center"></el-table-column>
				
				<el-table-column prop="create_time" label="创建时间" width="200" align="center"></el-table-column>
				
				<el-table-column prop="sort" width="300" label="排序" align="center">
					<template slot="header" slot-scope="scope">
						排序
						<el-tooltip content="数值越小越靠前" placement="top-end" effect="dark">
							<i class="el-icon-question"></i>
						</el-tooltip>
					</template>
					<template slot-scope="scope">
						<el-input-number class="sort" v-model="scope.row.sort" @change="changeSort($event,scope.row.index)" :min="0" label="排序" controls-position="right" ></el-input-number>
					</template>
				</el-table-column>
				
				<el-table-column prop="save" label="操作" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button class="op-btn" type="text" size="medium" @click="add(scope.row.index)">编辑</el-button>
						<el-button class="op-btn" type="text" size="medium" @click="del(scope.row.index)">删除</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		
		
		<dialog-tip :show="showDialogTip" @close="closeDialogTip"></dialog-tip>
		<dialog-del :show="showDialogDetele" :id="id" :cname="cname" @close="closeDialogDetele" @success="dialogDeteleSuccess"></dialog-del>
		<dialog-add :show="showDialogAdd" :id="id" :cname="cname" @close="closeDialogAdd" @success="dialogAddSuccess"></dialog-add>
	</div>
</template>

<script>
	import {
		getList,
		changeSort
	} from '@/api/classify';
	
	import dialogTip from '@/components/pro-group/dialog-tip.vue';
	import dialogDel from '@/components/pro-group/dialog-del.vue';
	import dialogAdd from '@/components/pro-group/dialog-add.vue';
	export default {
		data() {
			return {
				loading: false,
				list: [],
				
				oper_index: 0, // 当前操作的行下标
				showDialogTip: false, // 是否显示缩略图
				showDialogDetele: false, // 删除框
				showDialogAdd: false, // 添加框
				
				id: 0, // 当前操作的ID
				cname: '' // 当前操作的名称
			}
		},
		components: {
			dialogTip,
			dialogAdd,
			dialogDel
		},
		created() {
			this.getList();
		},
		methods: {
			getList(){
				this.loading = true;
				getList({
				}).then(res => {
					this.loading = false;
					if (res.code == 0) {
						this.list = res.data
					} else {
						this.$message.error(res.message);
					}
				})
			},
			
			// 调整排序
			changeSort(value = 0,index = 0){
				let id = this.list[index].id;
				changeSort({
					id: id,
					sort: value
				}).then(res => {
					if (res.code == 0) {
						this.getList();
						this.$message.success('修改成功');
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 增加表格内的索引
			tableRowClassName({row, rowIndex}) {
				//把每一行的索引放进row
				row.index = rowIndex;
			},
			
			// 打开预览
			showeDialogTip(){
				this.showDialogTip = true;
			},
			// 关闭预览
			closeDialogTip(){
				this.showDialogTip = false;
			},
			
			// 删除
			del(index = 0){
				this.oper_index = index;
				this.id = this.list[index].id;
				this.cname = this.list[index].name;
				this.showDialogDetele = true;
			},
			// 关闭删除框
			closeDialogDetele() {
				this.showDialogDetele = false;
			},
			// 确认删除成功
			dialogDeteleSuccess() {
				this.showDialogDetele = false;
				this.list.splice(this.oper_index,1); // 将数组从页面中删除
			},
			
			// 添加&编辑
			add(index = -1){
				this.oper_index = index;
				if(index > -1){
					this.id = this.list[index].id;
					this.cname = this.list[index].name;
				}else{
					this.id = 0;
					this.cname = '';	
				}
				this.showDialogAdd = true;
			},
			// 关闭添加&编辑
			closeDialogAdd() {
				this.showDialogAdd = false;
			},
			// 确认添加&编辑成功
			dialogAddSuccess() {
				this.showDialogAdd = false;
				this.getList();
			}
		}
	}
</script>

<style scoped>
	.group-warp{
		background: #FFFFFF;
		min-height: 670px;
		height: 86vh;
		font-family: PingFang-SC-Medium, PingFang-SC;
	}
	
	/* 顶部 */
	.header-box{
		padding: 20px;
		display: flex;
		align-items: center;
	}
	.header-box .header-tip{
		font-size: 12px;
		color: #0486FE;
		margin-left: 15px;
		cursor: pointer;
	}
	
	.list-box{
		margin: 0 10px;
	}
	.list-box .sort{
		width: 120px;
	}
	.list-box .op-btn{
		margin: 0 20px;
	}
</style>
